import { render, staticRenderFns } from "./ActivityHome.vue?vue&type=template&id=063ad9be&scoped=true&"
import script from "./ActivityHome.vue?vue&type=script&lang=js&"
export * from "./ActivityHome.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHome.vue?vue&type=style&index=0&id=063ad9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ad9be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063ad9be')) {
      api.createRecord('063ad9be', component.options)
    } else {
      api.reload('063ad9be', component.options)
    }
    module.hot.accept("./ActivityHome.vue?vue&type=template&id=063ad9be&scoped=true&", function () {
      api.rerender('063ad9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityHome.vue"
export default component.exports